import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "forwardedAs"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Button from 'components/Button';
import { useNavMenuContext } from './NavMenu';
import { jsx as _jsx } from "react/jsx-runtime";
function NavMenuButton(_ref) {
  var as = _ref.as,
    forwardedAs = _ref.forwardedAs,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useNavMenuContext = useNavMenuContext(),
    menuButtonProps = _useNavMenuContext.menuButtonProps;
  var Component = as || Button;
  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, otherProps), {}, {
    as: forwardedAs
  }, menuButtonProps));
}
export default NavMenuButton;